import { render } from "./NodePDF.vue?vue&type=template&id=2ad7dd92"
import script from "./NodePDF.vue?vue&type=script&lang=js"
export * from "./NodePDF.vue?vue&type=script&lang=js"
script.render = render

export default script